<template>
  <div>
    <div class="headertop">
      <div class="btn_box">
        <div class="num_btn" :class="{no_num_color:wear_num==0}" @click="openWearList">
          <div>数据同步异常提醒</div>
          <div class="num">{{wear_num}}</div>
        </div>
        <div class="num_btn" :class="{no_num_color:ele_num==0}" @click="openEleList">
          <div>低电量提醒</div>
          <div class="num">{{ele_num}}</div>
        </div>
        <div class="num_btn" :class="{no_num_color:li_num==0}" @click="openLiList">
          <div>离院未解绑</div>
          <div class="num">{{li_num}}</div>
        </div>
      </div>
      <div class="flex_space_between">
        <div class="num_btn aync_btn" @click="openDataSyncDeviceListDialog" v-if="mac">
          <img src="@/assets/data_sync_icon.png" alt />
          <div>同步数据</div>
        </div>
        <div class="tech_phone">
          <p style="margin-bottom:2px;">技术运维电话</p>
          <p>400-9616-639</p>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="ele_dialog" title="低电量提醒" width="900px" class="el_dialog">
      <div class="dialog_tips">请及时进行设备充电！</div>
      <el-table
        v-loading="eleDialogTableLoading"
        :key="tableKey"
        :data="eleDialogTableData"
        style="width: 100%; margin-bottom: 20px"
        border
        height="334px"
      >
        <el-table-column align="center" prop="ccid" label="设备CCID" width="200px"></el-table-column>
        <el-table-column align="center" prop="bed_number" label="床号"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="bat" label="电量">
          <template slot-scope="scope">
            <div style="color:red;">{{ scope.row.bat }}%</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="insert_time" label="电量同步时间" width="180px">
          <template slot-scope="scope">
            {{ scope.row.insert_time ? $dateFtt.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(scope.row.insert_time *
            1000))
            : '' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              class="table_btn_primary"
              @click="editBatStatus(scope.row, scope.$index)"
              size="small"
              v-show="scope.row.status !== 1"
            >处理</el-button>
            <el-button
              type="default"
              class="table_btn_primary"
              disabled
              size="small"
              v-show="scope.row.status == 1"
            >已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :page-sizes="[5]"
        :current-page="page"
        :page-size="5"
        layout="sizes,prev, pager, next,total"
        :total="ele_total"
      ></el-pagination>
    </el-dialog>
    <el-dialog :visible.sync="wear_dialog" title="数据同步异常提醒" width="900px" class="el_dialog">
      <el-table
        v-loading="wearDialogTableLoading"
        :data="wearDialogTableData"
        style="width: 100%; margin-bottom: 20px"
        border
        height="334px"
      >
        <el-table-column align="center" prop="ccid" label="设备CCID" width="200px"></el-table-column>
        <el-table-column align="center" prop="bed_number" label="床号"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="insert_time" label="数据同步异常时间">
          <template slot-scope="scope">
            {{ scope.row.insert_time ? $dateFtt.dateFtt('yyyy-MM-dd hh:mm', new Date(scope.row.insert_time *
            1000))+'~'+$dateFtt.dateFtt('hh:mm', new Date())
            : '' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChangeWear"
        :page-sizes="[5]"
        :current-page="wearPage"
        :page-size="5"
        layout="sizes,prev, pager, next,total"
        :total="wear_total"
      ></el-pagination>
    </el-dialog>
    <el-dialog
      :visible.sync="dataSyncDeviceListDialog"
      title="同步数据"
      width="900px"
      class="el_dialog"
    >
      <el-table
        v-loading="dataSyncDeviceListLoading"
        :data="allBindDeviceList"
        style="width: 100%; margin-bottom: 20px"
        border
        height="334px"
      >
        <el-table-column align="center" prop="ccid" label="设备CCID" width="280px"></el-table-column>
        <el-table-column align="center" prop="bed_number" label="床号"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="chooseDataSyncDevice(scope.row,0)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleDataSyncDeviceListCurrentChange"
        :page-sizes="[5]"
        :current-page="dataSyncDeviceListPage.page"
        :page-size="5"
        layout="sizes,prev, pager, next,total"
        :total="dataSyncDeviceListPage.total"
      ></el-pagination>
    </el-dialog>
    <el-dialog
      :visible.sync="dataSyncDialog"
      title="同步数据"
      width="508px"
      top="20vh"
      class="el_dialog"
      @close="closeDataSync"
    >
      <div class="data_sync_box" v-if="dataSyncStatus==0">
        <div class="text">请将需同步数据的手表拿至护士台中央站附近</div>
        <img src="@/assets/data_sync.png" />
        <div class="ccid">{{dataSyncObj.ccid}}</div>
        <div class="text">同步过程约为1-3分钟</div>
        <div>
          <el-button type="primary" @click="startDataSync()">开始同步</el-button>
        </div>
      </div>
      <div class="data_sync_box onloading" v-if="dataSyncStatus==1">
        <div class="text">正在同步中，请在手表界面查看同步状态</div>
        <div class="wave ripple">
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <img src="@/assets/data_sync.png" class="watch_img" />
          <img src="@/assets/watch_left_icon.png" class="left_icon" />
          <img src="@/assets/watch_right_icon.png" class="right_icon" />
        </div>
        <div class="ccid">{{dataSyncObj.ccid}}</div>
      </div>
      <div class="data_sync_box" v-if="dataSyncStatus==2">
        <div class="text">同步成功</div>
        <img src="@/assets/sync_success.png" />
        <div class="ccid">{{dataSyncObj.ccid}}</div>
        <div class="text">
          数据时间段为：{{Number(dataSyncObj.start_time)?$dateFtt.dateFtt('yyyy/MM/dd hh:mm', new Date(dataSyncObj.start_time *
          1000)):' --/--/-- --:-- '}}~{{Number(dataSyncObj.end_time)?$dateFtt.dateFtt('yyyy/MM/dd hh:mm', new Date(dataSyncObj.end_time *
          1000)):(Number(dataSyncObj.start_time)?$dateFtt.dateFtt('yyyy/MM/dd hh:mm', new Date(dataSyncObj.start_time *
          1000)):' --/--/-- --:-- ')}}
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="li_dialog" title="离院未解绑" width="900px" class="el_dialog">
      <el-table
        v-loading="liDialogTableLoading"
        :key="tableKey"
        :data="liDialogTableData"
        style="width: 100%; margin-bottom: 20px"
        border
        height="334px"
      >
        <el-table-column align="center" prop="name" label="患者姓名" width="200px"></el-table-column>
        <el-table-column align="center" prop="bed_number" label="离院前床号"></el-table-column>
        <el-table-column align="center" prop="ccid" label="设备CCID"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="unbindDevice(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChangeLi"
        :page-sizes="[5]"
        :current-page="pageLi"
        :page-size="5"
        layout="sizes,prev, pager, next,total"
        :total="li_total"
      ></el-pagination>
    </el-dialog>

    <el-dialog :visible.sync="tipsDialog" title="设备解绑" width="580px">
        <div class="_tips">
            <i class="el-icon-warning el-icon-iconName " color="#e6a23c"></i><span>是否将该设备进行解绑</span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="tipsDialog = false">取 消</el-button>
            <el-button type="primary" @click="setTipsDialog">确 定</el-button>
        </span>
    </el-dialog>


  </div>
</template>

<script>
import { _debounce } from "./../../utility/index"
export default {
  data() {
    return {
      ele_total: 0,
      wear_total: 1,
      zone_number: "",
      page: 1,
      eleDialogTableLoading: false,
      eleDialogTableData: [],
      ele_dialog: false,
      tableKey: 0,
      wear_num: 0,
      ele_num: 0,
      li_num:0,
      interval: 0,
      wearPage: 1,
      wearDialogTableLoading: false,
      wearDialogTableData: [],
      wear_dialog: false,
      mac: "",
      dataSyncDeviceListDialog: false,
      dataSyncDeviceListLoading: false,
      dataSyncDeviceListPage: {
        page: 1,
        perPage: 5,
        total: 0,
      },
      allBindDeviceList: [],
      dataSyncObj: {},
      dataSyncDialog: false,
      dataSyncStatus: 0, //0:未同步 1：同步中  2：同步成功   3：同步终止
      dataSyncInterval: 0,
      li_dialog:false,
      liDialogTableLoading:false,
      liDialogTableData:[],
      li_total:0,
      pageLi:1,
      tipsDialog:false,
      liitemData:{id:''},
    };
  },

  mounted() {
    this.zone_number = this.$cookies.get("zone_number");
    this.mac = this.$cookies.get("mac");
    this.getNum();
    this.timerFun(this.getNum, 60000, this)();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    openLiList(){
      this.pageLi = 1;
      this.li_dialog = true;
      this.fetchLiList();
    },
    fetchLiList(){
      let data = {
        zone_number: this.zone_number,
        page: this.pageLi,
        perPage: 5,
      };
      this.liDialogTableLoading = true;
      this.$http({
        url: "/api/device/end_list",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.liDialogTableLoading = false;
        this.liDialogTableData = res.result.data;
        this.li_total = res.result.total;
        // this.eleDialogTableData.forEach((item, index) => {
        //   this.eleDialogTableData[index].status = 0;
        // });
      });
    },
    unbindDevice(item){
      this.liitemData.id = item.id;
      this.tipsDialog = true;
      this.li_dialog = false;
    },
    setTipsDialog: _debounce(function(_type, index){
      let item = this.liitemData;
      let data = {
          zone_number: this.zone_number,
          id: item.id,
      };
      console.log('data',data)
      this.$http({
          url: "/api/device/end_out_bind",
          method: "POST",
          data: data,
          headers: {
              Token: this.$cookies.get("token"),
          },
      }).then((res) => {
          this.$message.success("解绑成功");
          this.tipsDialog = false;
          this.getNum();
      }).catch((err)=>{
        this.tipsDialog = false;
        this.getNum();
      })
    },500),
    timerFunDataSync(f, time, that) {
      return function backFun() {
        if (that.dataSyncInterval) {
          clearTimeout(that.dataSyncInterval);
        }
        that.dataSyncInterval = setTimeout(function () {
          f();
          backFun();
        }, time);
      };
    },
    startDataSync() {
      // this.dataSyncStatus = 1;
      let data = {
        zone_number: this.zone_number,
        ccid: this.dataSyncObj.ccid,
      };
      this.$http({
        url: "/api/data/bule_sync_data",
        method: "POST",
        data: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        console.log(1);
        this.dataSyncStatus = 1;
        this.timerFunDataSync(this.getStatusOnLoadingDialog, 5000, this)();
      });
    },
    getStatusOnLoadingDialog() {
      console.log(1);
      this.getDataSyncStatus().then((res) => {
        if (res.status == 200) {
          this.dataSyncStatus = 2;
          this.dataSyncObj = res.result;
          if (this.dataSyncInterval) {
            clearTimeout(this.dataSyncInterval);
          }
        }
      });
    },
    closeDataSync() {
      if (this.dataSyncStatus == 1) {
        this.dataSyncDeviceListDialog = false;
      }
      if (this.dataSyncInterval) {
        clearTimeout(this.dataSyncInterval);
      }
    },
    chooseDataSyncDevice(item, status) {
      this.dataSyncObj = item;
      this.dataSyncDialog = true;
      this.dataSyncStatus = status;

      // this.getDataSyncStatus();
    },
    getDataSyncStatus() {
      return new Promise((resolve, reject) => {
        let data = {
          zone_number: this.zone_number,
          // ccid:this.dataSyncObj.ccid
        };
        this.$httpSync({
          url: "/api/data/get_sync_status",
          method: "POST",
          data: data,
          headers: {
            Token: this.$cookies.get("token"),
          },
        })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
            this.$message({
              message: error.message,
              type: "error",
              duration: 5 * 1000,
            });
          });
      });
    },
    openDataSyncDeviceListDialog() {
      this.getDataSyncStatus().then((res) => {
        if (res.status == 200) {
          this.fetchAllBindDeviceList();
          this.dataSyncStatus = 0;
          this.dataSyncDeviceListDialog = true;
          this.dataSyncDeviceListLoading = true;
        } else {
          this.chooseDataSyncDevice(res.result, 1);
          this.timerFunDataSync(this.getStatusOnLoadingDialog, 5000, this)();
        }
      });
    },
    fetchAllBindDeviceList() {
      let data = {
        zone_number: this.zone_number,
        bind: 1,
        page: this.dataSyncDeviceListPage.page,
        perPage: this.dataSyncDeviceListPage.perPage,
      };
      this.$http({
        url: "/api/device/list",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.allBindDeviceList = res.result.data;
        this.dataSyncDeviceListLoading = false;
        this.dataSyncDeviceListPage.total = res.result.total;
      });
    },
    handleDataSyncDeviceListCurrentChange(e) {
      this.dataSyncDeviceListPage.page = e;
      this.fetchAllBindDeviceList();
    },
    timerFun(f, time, that) {
      return function backFun() {
        if (that.interval) {
          clearTimeout(that.interval);
        }
        that.interval = setTimeout(function () {
          f();
          backFun();
        }, time);
      };
    },
    getNum() {
      let data = {
        zone_number: this.zone_number,
      };
      this.$http({
        url: "/api/zone/notice",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.wear_num = res.result.wear;
        this.ele_num = res.result.bat;
        this.li_num = res.result.end
      });
    },
    openWearList() {
      this.wear_dialog = true;
      this.wearPage = 1;
      this.fetchWearList();
    },
    fetchWearList() {
      let data = {
        zone_number: this.zone_number,
        page: this.wearPage,
        perPage: 5,
      };
      this.wearDialogTableLoading = true;
      this.$http({
        url: "/api/hope/wear",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.wearDialogTableLoading = false;
        this.wearDialogTableData = res.result.data;
        this.wear_total = res.result.total;
      });
    },
    openEleList() {
      this.page = 1;
      this.ele_dialog = true;
      this.fetchEleList();
    },
    fetchEleList() {
      let data = {
        zone_number: this.zone_number,
        page: this.page,
        perPage: 5,
      };
      this.eleDialogTableLoading = true;
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.eleDialogTableLoading = false;
        this.eleDialogTableData = res.result.data;
        this.ele_total = res.result.total;
        this.eleDialogTableData.forEach((item, index) => {
          this.eleDialogTableData[index].status = 0;
        });
      });
    },
    editBatStatus(item, index) {
      this.eleDialogTableLoading = true;
      let data = { id: item.id };
      this.$http({
        url: "/api/hope/bat_status",
        method: "POST",
        data: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.eleDialogTableLoading = false;
        this.eleDialogTableData[index].status = 1;
        this.$nextTick(() => {
          this.tableKey++;
        });
        this.fetchBatNum();
      });
    },
    handleCurrentChangeWear(e) {
      this.wearPage = e;
      this.fetchWearList();
    },
    handleCurrentChangeLi(e){
      this.pageLi = e;
      this.fetchLiList();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchEleList();
      //   let data = {
      //     zone_number: this.zone_number,
      //     page: this.page,
      //     perPage: 5,
      //   };
      //   this.eleDialogTableLoading = true;
      //   this.$http({
      //     url: "/api/hope/bat",
      //     method: "GET",
      //     params: data,
      //     headers: {
      //       Token: this.$cookies.get("token"),
      //     },
      //   }).then((res) => {
      //     this.eleDialogTableLoading = false;
      //     this.eleDialogTableData = res.result.data;
      //     this.eleDialogTableData.forEach((item, index) => {
      //       this.eleDialogTableData[index].status = 0;
      //     });
      //     this.el_total = res.result.total;
      //   });
    },
  },
};
</script>
<style  scoped>
.headertop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 100%;
}
.btn_box {
  display: flex;
  align-items: center;
}
.num_btn {
  display: flex;
  align-items: center;
  height: 34px;
  padding: 0 12px;
  background-color: #e24040;
  color: #fff;
  border-radius: 5px;
  margin-right: 24px;
  cursor: pointer;
}
.num_btn:hover {
  opacity: 0.7;
}
.aync_btn {
  background-color: #3889ff !important;
}
.aync_btn img {
  width: 24px;
  margin-right: 4px;
}
.num {
  width: 24px;
  height: 24px;
  font-weight: bold;
  background-color: #fff;
  border-radius: 24px;
  color: #e24040;
  display: flex;
  align-items: center;
  /* text-align: center; */
  justify-content: space-around;
  margin-left: 12px;
}
.no_num_color {
  background-color: #cdcdcd !important;
}
.no_num_color .num {
  color: #cdcdcd;
}
.tech_phone {
  color: #2f3538;
}
.pagination {
  text-align: center;
}

.dialog_tips {
  font-size: 16px;
  margin-bottom: 20px;
}
.data_sync_box {
  text-align: center;
  height: 371px;
}
.data_sync_box .text {
  padding-bottom: 24px;
  padding-top: 24px;
  font-size: 16px;
  color: #636676;
}
.data_sync_box .ccid {
  font-size: 14px;
  color: #9296af;
  padding-bottom: 24px;
}
.data_sync_box > img {
  width: 112px;
  margin: 24px auto 10px;
}

/* 水波动画 */
.wave {
  position: relative;
  width: 112px;
  height: 112px;
  margin: 24px auto 10px;
  /* font-size: 28px; */
}
.wave .watch_img {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.wave .left_icon,
.wave .right_icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.wave .left_icon {
  left: -30px;
}
.wave .right_icon {
  right: -30px;
}
.wave .circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0;
  z-index: 2;
  left: -11px;
  top: -9px;
  width: 130px;
  height: 130px;
  border: 3px solid #fff;
}

/* 波纹效果 */

.wave.ripple .circle:first-child {
  animation: circle-opacity 3s infinite;
}

.wave.ripple .circle:nth-child(2) {
  animation: circle-opacity 3s infinite;
  animation-delay: 0.4s;
}

.wave.ripple .circle:nth-child(3) {
  animation: circle-opacity 3s infinite;
  animation-delay: 0.8s;
}
.wave.ripple .circle:nth-child(4) {
  animation: circle-opacity 3s infinite;
  animation-delay: 1.2s;
}
.wave.ripple .circle:nth-child(5) {
  animation: circle-opacity 3s infinite;
  animation-delay: 1.2s;
}
.wave.ripple .circle {
  border-color: #7dd1fa;
  box-shadow: 0 0 10px 10px #37bafc inset;
  background: rgba(255, 255, 255, 0.151);
}

._tips{
    height: 146px;
    line-height: 146px;
    color: #e6a23c;
    display: flex;
    align-items: center;
    justify-content: center;
}
._tips span{
    color: #636676;
    margin-left: 5px;
}
.el-icon-iconName{
    font-size: 20px;
}

@keyframes circle-opacity {
  from {
    opacity: 1;
    transform: scale(0);
  }
  to {
    opacity: 0;
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/view/layout/headertop.vue